import { color, strip } from '@central/ui';

const items = [
  { fill: strip.up, label: 'All services up' },
  { fill: strip.degraded, label: 'Degraded part of the day' },
  { fill: strip.down, label: 'Down for 5 min or more' },
  { fill: strip.maintenance, label: 'Planned maintenance' },
  { fill: strip.noData, label: 'No data' },
];

/** Key for the uptime strip colours. */
export function StripLegend() {
  return (
    <div
      style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 12, color: color.textMuted }}
    >
      {items.map((i) => (
        <span key={i.label} style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <span
            aria-hidden
            style={{ width: 10, height: 10, borderRadius: 2, background: i.fill }}
          />
          {i.label}
        </span>
      ))}
    </div>
  );
}

/** "30 days ago … Today" under a strip. */
export function StripEnds({ days }: { days: number }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 12,
        color: color.textMuted,
      }}
    >
      <span>{days} days ago</span>
      <span>Today</span>
    </div>
  );
}
